import React from 'react'
import { Center, HStack, Icon } from '@chakra-ui/react'
import { Controller, useFormContext } from 'react-hook-form'
import { MdStorefront } from 'react-icons/md'
import { GrandRadioCard } from 'ui'
import { overrideText } from 'ui/lib/overrides'
import { TbTruckDelivery } from 'react-icons/tb'

interface DeliveryMethodOption {
  value: string
  label: string
  description: string
  icon: React.ComponentType
}

interface PostnordDeliveryMethodSelectorProps {
  name?: string
  overrides?: {
    pickUpInStore?: string
    pickUpInStoreDescription?: string
    deliveryOption?: string
    deliveryOptionDescription?: string
  }
}

export const PostnordDeliveryMethodSelector: React.FC<PostnordDeliveryMethodSelectorProps> = ({
  name = 'isPickupFromStore',
  overrides
}) => {
  const { control, setValue, watch } = useFormContext()
  const selectedValue = watch(name)

  // Define delivery method options
  const deliveryOptions: DeliveryMethodOption[] = [
    {
      value: 'false',
      label: overrideText('Leverans', overrides?.deliveryOption),
      description: overrideText(
        'Vi levererar till din adress',
        overrides?.deliveryOptionDescription
      ),
      icon: TbTruckDelivery
    },
    {
      value: 'true',
      label: overrideText('Hämta i butik', overrides?.pickUpInStore),
      description: overrideText(
        'Hämta i vår butik (frakt tas bort)',
        overrides?.pickUpInStoreDescription
      ),
      icon: MdStorefront
    }
  ]

  return (
    <Controller
      control={control}
      name={name}
      render={({ fieldState: { error } }) => (
        <GrandRadioCard.Root
          value={selectedValue?.toString() || 'false'}
          onChange={(value) => setValue(name, value === 'true')}
          size="md"
          variant="outline"
        >
          <HStack alignItems="stretch" gap={4}>
            {deliveryOptions.map((option) => (
              <GrandRadioCard.Item
                key={option.value}
                value={option.value}
                flex="1"
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
              >
                <Center gap={3} h="100%" flexDirection="column">
                  <Icon as={option.icon} boxSize={6} color="blue.500" />
                  <GrandRadioCard.ItemContent align="center">
                    <GrandRadioCard.ItemText textAlign="center">
                      {option.label}
                    </GrandRadioCard.ItemText>
                    <GrandRadioCard.ItemDescription textAlign="center">
                      {option.description}
                    </GrandRadioCard.ItemDescription>
                  </GrandRadioCard.ItemContent>
                </Center>
              </GrandRadioCard.Item>
            ))}
          </HStack>
          {error && (
            <GrandRadioCard.ItemDescription color="red.500">
              {error.message}
            </GrandRadioCard.ItemDescription>
          )}
        </GrandRadioCard.Root>
      )}
    />
  )
}

export default PostnordDeliveryMethodSelector
